import React, { Component } from 'react';
import {
    Col, InputGroup, Input,
    FormGroup, Label, InputGroupAddon, InputGroupText, Row
} from 'reactstrap';
import './fields.css'
import axios from "axios";
import driver from '../../Assets/images/Logo.png';
// import car from '../../assets/Images/car.jpg'
import { API_ENDPOINT } from '../../AppConfig'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { showLoading, hideLoading } from 'react-redux-loading-bar';
import String from "../../Assets/locals.js"

class CustomInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isGoing: true,
            imagePreviewUrl: null,
            fileSelected: null,
            previouslang: null,
            previousuri: null,
            // PricingPlansTypesEN:[
            //     {name:"FREE",id:"FREE"},
            //     {name:"SINGLE",id:"SINGLE"},
            //     {name:"MULTIPLE",id:"MULTIPLE"}
            // ],
            // PricingPlansTypesAR:[
            //     {name:"مجانية",id:"FREE"},
            //     {name:"فردى",id:"SINGLE"},
            //     {name:"مجموعة",id:"MULTIPLE"},
            // ]


        }

    }
    handelOption(event, name, ) {
        let object = name.name
        object = object.split("_")
        if (object[0] === "carType") {
            this.props.selectoronChange(event.target.value, object[1])

        }

    }
    fetchRequest(uri, lang) {
        let token = 'Bearer ' + this.props.token
        let url = `${API_ENDPOINT}` + uri
        axios.get(url, {
            headers: {
                'Authorization': token,
                "Accept-Language": lang
            }
        })
            .then(response => {
                const info = response.data.data;
                this.setState({ object: info, previousuri: uri }, () => {
                });
            }).catch(error => {
            })
    }
    handleChange(e, input) {
        e.preventDefault();

        let reader = new FileReader();
        let file = e.target.files[0];
        // this.setState({ fileSelected: file.name })
        reader.onloadend = () => {
            input.onChange(file);
            this.setState({
                file: file,
                fileSelected: file.name,
                imagePreviewUrl: reader.result
            });
        }
        if (file) {
            reader.readAsDataURL(file)
        }
    }
    handleCheckChange = (e, id, flagName) => {
        if (e.target.name === "all") {
            this.Check(e.target.checked, flagName)
        } else {
            if (e.target.checked) {
                this.props.handlepush(id, flagName)
            }
            else {
                this.props.handleremove(id, flagName)
            }
        }

    }
    Check(check, name) {
        if (check) {
            this.state.object.map(elment => this.props.handlepush(elment.id, name))
        }
        else {
            this.props.handleremove("all", name)
        }
        var x = document.getElementsByClassName(name);
        for (let i = 0; i < x.length; i++) {
            x[i].checked = check;
        }
    }
    componentWillMount() {
        if (this.props.imagepreview) {
            let imageurl = this.props.imagepreview
            this.setState({ imagePreviewUrl: imageurl })
        }
        this.setState({ previouslang: this.props.lang })
        if (this.props.uri) {
            this.fetchRequest(this.props.uri, this.props.lang)
        }

    }
    render() {
        const { lang, placeholder, uploaded, section, child, input, name, options, type, icone, size, title, label, keyId, keyElement, optionTitle, filetype, meta: { touched, error } } = this.props
        const object = this.state.object
        let { imagePreviewUrl, fileSelected } = this.state;
        let $imagePreview = null;
        if (imagePreviewUrl) {
            if (uploaded === "avater") {
                $imagePreview = (<img src={imagePreviewUrl} alt="category" />);
            } else {
                $imagePreview = fileSelected
            }
        }
        if (this.state.previouslang !== this.props.language && this.props.uri) {
            this.setState({ previouslang: this.props.language })
            this.fetchRequest(this.props.uri, this.props.language)
        }
        if (this.state.previousuri !== this.props.uri) {
            this.setState({ previousuri: this.props.uri })
            this.fetchRequest(this.props.uri, this.props.language)
        }
        return (

            // <div>

            <Col className={this.props.classfield} lg={size ? size.lg : "4"} md={size ? size.md : "12"}>
                {type === "LABEL" &&
                    <Label className={lang === "en" ? "labelInput LeftAlign pl-4" : "labelInput RightAlign pr-4"} style={{ display: label.length === 0 ? "none" : "" }}>
                         {this.props.astrics && <span style={{ color: "red", fontSize: "15px", fontWeight: "800", marginRight: ".7rem" }}>*</span>}
                        {label}
                    </Label>
                }
                {type !== "LABEL" &&
                    <FormGroup>
                        <div style={{ width: "100%" }}>
                            <InputGroup>
                                <Label className={lang === "en" ? "labelInput LeftAlign" : "labelInput RightAlign"} style={{ display: label.length === 0 ? "none" : "" }}>
                                {this.props.astrics && <span style={{ color: "red", fontSize: "15px", fontWeight: "800", marginRight: ".7rem" }}>*</span>}
                                    {label} 
                                </Label>
                                {/* Radio Button Input */}
                                {(type === "radio") &&
                                    <div className="checkboxlabel">
                                        <div style={{ display: "inline-block", paddingTop: label ? "" : "1.5rem" }}>
                                            <Input  {...input} type={type} name={name} />{' '}<span>{title}</span>
                                        </div>
                                    </div>
                                }
                                {(type === "checkbox") &&
                                    <div className="checkboxlabel">
                                        <div style={{ display: "inline-block", paddingTop: label ? "" : "1.5rem" }}>
                                            {/* <Input  {...input} type={type} name={name} />{' '}<span>{title}</span> */}
                                            {/* <Input  {...input} checked={this.state.isGoing} type={type} name={name} />{' '}<span>{title}</span> */}
                                            <Row>

                                                {object && object.map((element, index) => {
                                                    if (index === 0) {
                                                        return (
                                                            <div style={{ width: "92%", display: "inline-flex" }}>
                                                                <Col lg={size ? size.sub : "4"} md={size ? size.sub : "12"} className="my-2">
                                                                    <input
                                                                        name={section}
                                                                        type={type}
                                                                        className={this.props.flag}
                                                                        flag={name}
                                                                        // accept={filetype}
                                                                        onChange={(e) => { this.handleCheckChange(e, "", this.props.flag) }}
                                                                    // onChange={event => this.handleCheckChange(name)}
                                                                    />{' '}<span>{title}</span>
                                                                </Col>
                                                                <Col lg={size ? size.sub : "4"} md={size ? size.sub : "12"}>

                                                                    <input
                                                                        // name={section}
                                                                        type={type}
                                                                        className={this.props.flag}
                                                                        flag={name}
                                                                        // accept={filetype}
                                                                        onChange={(e) => { this.handleCheckChange(e, element[keyId], this.props.flag) }}
                                                                    // onChange={event => this.handleCheckChange(name)}
                                                                    />{' '}<span>{element[keyElement]}</span>

                                                                </Col>
                                                            </div>

                                                        )

                                                    }
                                                    return (
                                                        <Col lg={size ? size.sub : "4"} md={size ? size.sub : "12"}>

                                                            <input
                                                                // name={section}
                                                                type={type}
                                                                className={this.props.flag}
                                                                // accept={filetype}
                                                                flag={name}
                                                                onChange={(e) => { this.handleCheckChange(e, element[keyId], this.props.flag) }}
                                                            // onChange={event => this.handleCheckChange(name)}
                                                            />{' '}<span>{element[keyElement]}</span>

                                                        </Col>
                                                    )

                                                })
                                                }
                                            </Row>



                                        </div>
                                    </div>
                                }

                                {/* select Box Input */}
                                {type === "select" &&
                                    (this.props.dropdownModal ?

                                        <Input {...input} placeholder={placeholder} style={{ direction: lang === "ar" ? "rtl" : "ltr" }}
                                            // onChange={event => this.handelOption(event, input)}
                                            type={type} name={name} style={{ backgroundColor: this.props.background ? this.props.background : "#FFFFFF" }} >
                                            {optionTitle && <option value={0}>{optionTitle}</option>}
                                            {options ?
                                                options.map((element, index) => {
                                                    return (
                                                        <option key={index} value={element.value}>{lang === "ar" ? element.title.ar : element.title.en}</option>
                                                    )
                                                }) :
                                                object && object.map((element, index) => {
                                                    if (child && element[child]) {
                                                        let childobj = element[child]
                                                        return (
                                                            <option key={index} value={keyId ? childobj[keyId] : JSON.stringify(element)}>{childobj[keyElement]}</option>
                                                        )


                                                    }
                                                    else {
                                                        return (
                                                            <option value={keyId ? element[keyId] : JSON.stringify(element)}>{element[keyElement] ? element[keyElement] : `${element.height.value}-${element.width.value}-${element.diameter.value}`}</option>
                                                        )
                                                    }


                                                })
                                            }
                                        </Input>
                                        :

                                        <Input {...input} placeholder={placeholder}
                                            type={type} name={name} style={{ backgroundColor: this.props.background ? this.props.background : "#FFFFFF" }} >
                                            {optionTitle && <option value={0}>{optionTitle}</option>}
                                            {options ?
                                                options.map((element, index) => {
                                                    return (
                                                        <option key={index} value={element.value}>{lang === "ar" ? element.title.ar : element.title.en}</option>
                                                    )
                                                }) :
                                                object && object.map((element, index) => {
                                                    if (child && element[child]) {
                                                        let childobj = element[child]
                                                        return (
                                                            <option key={index} value={keyId ? childobj[keyId] : JSON.stringify(element)}>{childobj[keyElement]}</option>
                                                        )


                                                    }
                                                    else {
                                                        return (
                                                            <option value={keyId ? element[keyId] : JSON.stringify(element)}>{element[keyElement] ? element[keyElement] : `${element.height.value}-${element.width.value}-${element.diameter.value}`}</option>
                                                        )
                                                    }


                                                })
                                            }
                                        </Input>
                                    )}
                                {/* Text Input */}
                                {type !== "radio" && type !== "select" && type !== "checkbox" && type !== "file" &&
                                    <Input {...input} placeholder={placeholder} type={type} name={name} style={{ direction: lang === "ar" ? "rtl" : "ltr", backgroundColor: this.props.background ? this.props.background : "#FFFFFF" }} />
                                }
                                {type === "file" &&
                                    <div className=" upload" style={{ borderRadius: (uploaded !== "user" && uploaded !== "avatar") ? "" : "50%" }}>
                                        {uploaded === "user" ?
                                            <img className="btn-file-input" src={this.state.imagePreviewUrl ? (this.state.imagePreviewUrl) :
                                                this.props.userimagepreview ?
                                                    (this.props.userimagepreview)
                                                    : driver} alt="driver" style={{ height: "160px" }} />
                                            :
                                            uploaded !== "avatar" ?
                                                <img className="btn-file-input" src={this.state.imagePreviewUrl ?

                                                    (this.state.imagePreviewUrl) :
                                                    this.props.userimagepreview ?
                                                        (this.props.userimagepreview) :
                                                        driver} alt="avatar" style={{ height: "160px" }} />

                                                :
                                                uploaded === "object" ?
                                                    this.state.imagePreviewUrl || this.props.userimagepreview ?
                                                        <div>
                                                            <img className="btn-file-input" src={this.state.imagePreviewUrl ?
                                                                (this.state.imagePreviewUrl) :
                                                                this.props.userimagepreview ?
                                                                    (API_ENDPOINT + this.props.userimagepreview) :
                                                                    driver} alt="avatar" style={{ height: "160px" }} />
                                                            {this.props.mainimage &&
                                                                <div style={{ textAlign: "center" }}>
                                                                    <span style={{ color: "#2771a6" }}>{this.props.caption} </span>
                                                                    {/* <span style={{ color: "#2771a6" }}>  الرئيسية بالتطبيق </span> */}
                                                                </div>
                                                            }
                                                        </div>

                                                        :
                                                        (
                                                            <div>
                                                                <div style={{ backgroundColor: "#FFFF", margin: "0 auto", textAlign: "center", height: "100px", border: "1px dotted grey" }}>
                                                                    <div style={{ backgroundColor: "#4b7eb0", borderRadius: "50%", width: "31px", margin: "auto", marginTop: "20%" }}>
                                                                        {/* <i className="fa fa-plus" style={{ color: "#FFFF" }} ></i> */}
                                                                    </div>
                                                                </div>
                                                                {this.props.mainimage &&
                                                                    <div style={{ textAlign: "center" }}>
                                                                        <span style={{ color: "#2771a6" }}>{this.props.caption} </span>
                                                                        {/* <span style={{ color: "#2771a6" }}>  </span> */}
                                                                    </div>
                                                                }

                                                            </div>
                                                        )
                                                    :
                                                    <i className="fas fa-cloud-upload-alt" style={{ top: "5px", right: "9px", fontSize: "3rem" }}></i>


                                        }
                                        {this.props.uploadcaption &&
                                            <div>
                                                <p style={{ position: "relative", bottom: "1rem", margin: "0px", textAlign: "center", backgroundColor: "black", color: "white", opacity: ".7", height: "100%" }} >{String.editimg}</p>
                                            </div>
                                        }


                                        <input
                                            name={input.name}
                                            type={type}
                                            accept={filetype}
                                            onChange={event => this.handleChange(event, input)}
                                        />

                                    </div>

                                }
                                {icone &&
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>
                                            <i className={icone}></i>
                                        </InputGroupText>
                                    </InputGroupAddon>
                                }
                            </InputGroup >
                            {type === "file" ? <div className="text-center" style={{ marginTop: "10px" }}>
                                {touched && ((error && <span className="mt-3 erroMSG" style={{ color: "red", fontSize: "0.8rem" }}> {lang === "en" ? error.en : error.ar}</span>))}
                            </div> :
                                <div className={lang === "en" ? "LeftAlign" : "RightAlign"} style={{ marginTop: "10px" }}>
                                    {touched && ((error && <span className="mt-3 erroMSG" style={{ color: "red", fontSize: "0.8rem" }}> {lang === "en" ? error.en : error.ar}</span>))}
                                </div>
                            }
                        </div>
                    </FormGroup>


                }
                {/* {uploaded !== "user" && uploaded === "avater" && this.state.imagePreviewUrl &&
                    <div className="imgPreview add-imgPreview">
                        {$imagePreview}
                        <i onClick={() => this.setState({ imagePreviewUrl: null, file: null })} className={uploaded === "image" ? "fa fa-window-close close" : "fa fa-window-close"}></i>
                    </div>} */}
            </Col>
        )
    }

}
const mapStateToProps = state => {
    return {
        token: state.login.token,
        language: state.login.language

    }
}
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        showLoading,
        hideLoading

    }
    , dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(CustomInput)